<template>
  <div class="box">
    <Tabs :datas="tabDatas" v-model="selected" class-name="h-tabs-card"></Tabs>
    <component :is="selected"></component>
  </div>
</template>

<script>

import SupplierMapping from './SupplierMapping'
import MaterialMapping from './MaterialMapping'
/**
 * 用于设置进销存参数。
 * 该组件通过 Tabs 组件提供选项卡切换功能，支持供货商映射和物料映射两个功能模块。
 */
export default {
  name: "SetJxcParam",
  components: {SupplierMapping,MaterialMapping},
  data() {
    return {
      tabDatas: [
        {
          title: '供货商映射',
          key: 'SupplierMapping'
        }, {
          title: '物料映射',
          key: 'MaterialMapping'
        }],
      selected: 'SupplierMapping',
    }
  },
}
</script>
